/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProductsRequestPost } from '../../models/get-products-request-post';
import { ProductsResponseGetRecordsList } from '../../models/products-response-get-records-list';

export interface ProductsControllerFetchProducts$Params {
      body: GetProductsRequestPost
}

export function productsControllerFetchProducts(http: HttpClient, rootUrl: string, params: ProductsControllerFetchProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductsResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, productsControllerFetchProducts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductsResponseGetRecordsList>;
    })
  );
}

productsControllerFetchProducts.PATH = '/planning-projects/v1/products';
